export default __webpack_public_path__ + "6b79986334eb5821abd3f842dc851775.svg";